<div class="container my-3 p-4">
  <div class="row">
    <div class="col-12">
      @if (!isEbmsUser) {
      <h1 class="page-title">{{ "WELCOME_BACK" | globalTranslate }}</h1>
      } @if (isEbmsUser) {
      <h1 class="page-title">
        {{ "WELCOME_APPLY_COVERAGE_HEADER" | globalTranslate }}
      </h1>
      }
    </div>
  </div>

  @if (!mobileUser) {
  <div class="ps-1 pb-1 hover-red">
    <div
      tabindex="0"
      class="btn btn-link hover-red"
      (click)="onPreviousClick()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.875"
        height="15.75"
        viewBox="0 0 16.875 15.75"
      >
        <g
          id="_icons_arrow-back-outline"
          data-name="⚛️ icons/arrow-back-outline"
          transform="translate(0)"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
            transform="translate(0)"
            fill="#174a7c"
          />
        </g>
      </svg>
      <span class="ps-2">{{ "BACK_TO_PREVIOUS_PAGE" | globalTranslate }}</span>
    </div>
  </div>
  }

  <div class="bg-white p-4">
    @if (!isKepro && !isEbmsUser) {
    <p class="static-text">{{ "FROM_HERE" | globalTranslate }}</p>
    } @if (isEbmsUser) {
    <p class="static-text">{{ "FROM_HERE_DHS" | globalTranslate }}</p>
    } @if (isKepro) {
    <p class="static-text">{{ "AHS_FROM_HERE" | globalTranslate }}</p>
    }
    <div>
      @if (!isEbmsUser) {
      <h2 class="section-header">{{ "WELCOME_BACK" | globalTranslate }}</h2>
      }
      <hr />

      @if (!isEbmsUser) {
      <div
        tabindex="0"
        class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
        [ngClass]="{ applyColor: appType === 'continue' }"
        (click)="select('continue')"
      >
        <div
          class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
          aria-hidden="true"
        >
          <img
            class="dot"
            src="../../../assets/images/Icons/Start_new_app.svg"
          />
        </div>
        <div class="flex-grow-1 min-w-0 w-100">
          @if (!isKepro && !isEbmsUser) {
          <div class="section-column">
            <strong class="tile_header">{{
              "TAKE_ME_BACK" | globalTranslate
            }}</strong>
            @if (applicationNum && headOfHouseholdName) {
            <div class="tile-text small">
              {{ "HEAD_OF_HOUSEHOLD" | globalTranslate }}:
              <span class="me-1 transform">{{ headOfHouseholdName }}</span>
              @if (headOfHouseholdName.length <= 1) {
              <span class="visually-hidden">blank</span>
              }
            </div>
            } @if (applicationNum && lastAccessed) {
            <div class="tile-text small">
              {{ "LAST_ACCESSED" | globalTranslate }}:
              <span class="me-1">{{ lastAccessed | date: "MM/dd/yyyy" }}</span>
            </div>
            }
          </div>
          } @if (isKepro) {
          <div class="section-column">
            <strong class="tile_header"
              >Continue in progress application</strong
            >
            @if (headOfHouseholdName) {
            <div class="tile-text small mt-3">
              {{ "HEAD_OF_HOUSEHOLD" | globalTranslate }}:
              <span class="me-1 transform">{{ headOfHouseholdName }}</span
              ><span>{{ hohDob }}</span
              ><span>{{ hohGender }}</span>
            </div>
            } @if (hohSSN) {
            <div class="tile-text small">
              SSN: <span class="me-1 transform">{{ hohSSN }}</span>
            </div>
            } @if (appStartedBy) {
            <div class="tile-text small">
              Started By: <span class="me-1 transform">{{ appStartedBy }}</span>
            </div>
            } @if (appStartOn) {
            <div class="tile-text small">
              Started On:
              <span class="me-1 transform">{{
                appStartOn | date: "MM/dd/yyyy"
              }}</span>
            </div>
            } @if (lastAccessedBy) {
            <div class="tile-text small">
              Last Accessed By:
              <span class="me-1 transform">{{ lastAccessedBy }}</span>
            </div>
            } @if (lastAccessed) {
            <div class="tile-text small">
              Last Accessed On:
              <span class="me-1">{{ lastAccessed | date: "MM/dd/yyyy" }}</span>
            </div>
            }
          </div>
          }
        </div>
      </div>
      } @if (isEbmsUser) {
      <div
        tabindex="0"
        class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
        [ngClass]="{ applyColor: appType === 'ebmsFlow' }"
        (click)="select('ebmsFlow')"
        role="button"
      >
        <div
          class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
          aria-hidden="true"
        >
          <img
            class="dot"
            src="../../../assets/images/Icons/Start_new_app.svg"
          />
        </div>
        <div class="flex-grow-1 min-w-0 w-100">
          <div class="section-column eb-padding">
            <strong class="tile_header">{{
              "COMPLETE_DHS" | globalTranslate
            }}</strong>
            <div class="tile-text small">
              {{ "COMPLETE_DHS_2" | globalTranslate }}
            </div>
          </div>
        </div>
      </div>
      }
      <div
        tabindex="0"
        class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
        [ngClass]="{ applyColor: appType === 'new' }"
        (click)="select('new')"
      >
        <div
          class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
          aria-hidden="true"
        >
          <img class="dot" src="../../../assets/images/Icons/Take_back.svg" />
        </div>
        <div class="flex-grow-1 min-w-0 w-100">
          <div class="section-column spl-padding">
            <strong class="tile_header">{{
              "START_NEW_APPLICATION" | globalTranslate
            }}</strong>
          </div>
        </div>
      </div>

      @if (setMessage) {
      <div class="alert alert-danger" role="alert">
        {{ setMessage | globalTranslate }}
      </div>
      }
    </div>
  </div>
  <div class="row mt-3 m-1">
    <button
      tabindex="0"
      id="continue"
      class="col-md-2 btn d-grid btn-secondary"
      [ngClass]="{ clickedEBMSWelcomeBk: appType === 'ebmsFlow' }"
      (click)="next()"
      [disabled]="appType === ''"
    >
      {{ "NEXT" | globalTranslate }}
    </button>
  </div>
</div>